import React, {useState, useEffect} from "react";
import {useFormik} from "formik";
import * as Yup from "yup";
import {useNavigate, useParams} from "react-router-dom";
import {createProviderApi, getProviderApi, updateProviderApi} from "../../../../services/Admin/provider";
import {Grid, Box, Button, Switch, TextField, FormControlLabel} from "@mui/material";
import LoadingProgress from "../../../../components/LoadingProgress";
import {RouteAdmin} from "../../../../routes/RouteAdmin";
import Card from "../../../../components/Admin/Card";

export default function Fields() {
    const {id} = useParams()
    const history = useNavigate()

    const [msgSuccess, setMsgSuccess] = useState(false)
    const [msgDanger, setMsgDanger] = useState(null)
    const [loading, setLoading] = useState(true)
    const [initialValues, setInitialValues] = useState(defaultValues())
    const [disableButton, setDisableButton] = useState(false)

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object(validationSchema()),
        enableReinitialize: true,
        onSubmit: async (formData) => {
            setMsgSuccess(false)
            setMsgDanger(null)
            setDisableButton(true)
            if (id) {
                updateProviderApi(formData).then(resp => {
                    if (resp.data.status == false) {
                        setMsgDanger(resp.data.errors)
                    }else
                    {
                        setMsgDanger(null)
                        setMsgSuccess(true)
                    }
                    setDisableButton(false)
                }).catch(err => {
                    setMsgDanger(err.response.errors)
                    setDisableButton(false)
                })
            } else {
                createProviderApi(formData).then(resp => {
                    if (resp.data.status == false) {
                        setMsgDanger(resp.data.errors)
                    }else
                    {
                        setMsgDanger(null)
                        setMsgSuccess(true)
                        history(`/dash-admin/proveedores/edit/${resp.data.data.id}`);
                    }
                    setDisableButton(false)
                   
                }).catch(err => {
                    setMsgDanger(err.response?.errors)
                    setDisableButton(false)
                })
            }
        },
    })

    // Llamamos a la API para obtener los datos del servicio
    useEffect(() => {
        if (id) {
            getProviderApi({id: id}).then(resp => {
                setInitialValues({
                    id: resp.data.data.id,
                    name: resp.data.data.name,
                    nif: resp.data.data.nif,
                    irpf: resp.data.data.irpf,
                    isIrpf: resp.data.data.isIrpf,
                })
                setLoading(false)
            }).catch(err => {
                setLoading(false)
            })
        } else {
            setLoading(false)
        }
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Card>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12} lg={12}>
                        <h1>Configuraciones de proveedor</h1>
                    </Grid>

                    <Grid item xs={12} md={12} lg={12}>
                        <LoadingProgress loading={loading}/>

                        {!loading && (
                            <>
                                {msgSuccess && (
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Box className="alert-success">
                                            Los datos del proveedor se han guardado correctamente
                                        </Box>
                                    </Grid>
                                )}

                                {msgDanger && (
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Box className="alert-danger">
                                            {msgDanger.map((item) => {
                                                return (
                                                    <span>
                                                {" "}
                                                        {item} <br/>{" "}
                                            </span>
                                                );
                                            })}
                                        </Box>
                                    </Grid>
                                )}

                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={12} lg={12}>
                                        {id && (
                                            <div className="mb-2">
                                                <TextField
                                                    variant="outlined"
                                                    label="* ID proveedor"
                                                    className="form-control"
                                                    name="name"
                                                    type="text"
                                                    value={formik.values.id}
                                                    onChange={formik.handleChange}
                                                    disabled
                                                    fullWidth
                                                    size="small"
                                                />
                                            </div>
                                        )}
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={3} lg={3}>
                                                <div className="mb-2">
                                                    <TextField
                                                        variant="outlined"
                                                        label="* Nombre o Razón social"
                                                        className="form-control"
                                                        name="name"
                                                        type="text"
                                                        value={formik.values.name}
                                                        onChange={formik.handleChange}
                                                        fullWidth
                                                        size="small"
                                                    />
                                                    {formik.errors.name && (
                                                        <p className="text-100 text-danger mt-1">
                                                            {formik.errors.name}
                                                        </p>
                                                    )}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4} md={3} lg={3}>
                                                <div className="mb-2">
                                                    <TextField
                                                        variant="outlined"
                                                        label="* NIF/CIF"
                                                        className="form-control"
                                                        name="nif"
                                                        type="text"
                                                        value={formik.values.nif}
                                                        onChange={formik.handleChange}
                                                        fullWidth
                                                        size="small"
                                                    />
                                                    {formik.errors.nif && (
                                                        <p className="text-100 text-danger mt-1">
                                                            {formik.errors.nif}
                                                        </p>
                                                    )}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4} md={3} lg={3}>
                                                <TextField
                                                    variant="outlined"
                                                    label="* IRPF (%)"
                                                    className="form-control"
                                                    name="irpf"
                                                    type="number"
                                                    value={formik.values.irpf ?? ""}
                                                    onChange={formik.handleChange}
                                                    helperText="Indique 7 para especificar un 7%"
                                                    fullWidth
                                                    size="small"
                                                    />
                                            </Grid>
                                            <Grid item xs={12} md={4} lg={3}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={formik.values.isIrpf}
                                                            onChange={(event) => {
                                                                const checked = event.target.checked;
                                                                formik.setFieldValue("isIrpf", checked);
                                                                if (!checked) {
                                                                formik.setFieldValue("irpf", null); // o "" si prefieres vacío
                                                                }
                                                            }}
                                                            name="isIrpf"
                                                            color="primary"
                                                        />
                                                    }
                                                    label="IRPF"
                                                />
                                            </Grid>
                                            <Grid container spacing={3} className="mt-2">
                                                <Grid xs={12} md={4} lg={3} >
                                                    {formik.errors.irpf && (
                                                        <p className="text-100 text-danger mt-1 px-4">
                                                            {formik.errors.irpf}
                                                        </p>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        )}
                    </Grid>

                    <Grid item md={12}>
                        {!loading ? (
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <div style={{ width: 200 }}>
                                    <Button
                                        type="button"
                                        href={RouteAdmin.PROVIDER_MANAGEMENT.path}
                                        variant="contained"
                                        className="MuiButton-containedCancel"
                                        fullWidth
                                    >
                                        Cancel
                                    </Button>
                                </div>
                                <div style={{ width: 200, marginLeft: 20 }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        fullWidth
                                        disabled={disableButton}
                                    >
                                        Guardar
                                    </Button>
                                </div>
                            </div>
                        ) : null}
                    </Grid>
                </Grid>
            </form>
        </Card>
    );

}

// Declaramos los objetos del formulario
function defaultValues() {
    return {
        id: "",
        name: "",
        nif: "",
        irpf: "",
        isIrpf: true
    }
}

function validationSchema() {
    return {
        name: Yup.string().required("El nombre es obligatorio"),
        nif: Yup.string().required("El NIF/CIF del proveedor es obligatorio"),
        isIrpf: Yup.boolean(),
        irpf: Yup.number()
            .typeError('Introduzca los decimales con el punto, ej: 3.23')
            .when('isIrpf', {
            is: true,
            then: schema => schema.required('El IRPF es obligatorio si esta activo'),
            otherwise: schema => schema.nullable().notRequired(),
            }),
    }
}
